import { Injectable, inject } from '@angular/core';

import { STRING_CONSTANTS } from '@shared-constants';

import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

/**
 * Reads company-level feature flags for the active company from the auth
 * cookie. Centralizes checks that were previously duplicated across forms.
 */
@Injectable({
  providedIn: 'root',
})
export class CompanyFeaturesService {
  private readonly cookieAuthService = inject(CookieAuthService);

  /**
   * True when the active company issues electronic invoices through Billy
   * (`external_electronic_invoicing === 'true'`). Non-Billy companies resolve
   * Colombian cities from the internal source instead of Billy REST.
   */
  isBillyCompany(): boolean {
    return (
      this.cookieAuthService.getCompanyObject?.external_electronic_invoicing ===
      STRING_CONSTANTS.TRUE
    );
  }

  /**
   * True when the active company issues electronic invoices through our own
   * DIAN integration (`internal_electronic_invoicing === 'true'`).
   */
  isInternalInvoicingCompany(): boolean {
    return (
      this.cookieAuthService.getCompanyObject?.internal_electronic_invoicing ===
      STRING_CONSTANTS.TRUE
    );
  }
}
